import {
  Component,
  ChangeDetectionStrategy,
  DestroyRef,
  inject
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { debounceTime } from 'rxjs';

import { FileDownloadListComponent } from '@file-upload/components/file-download-list/file-download-list.component';
import { FilesStateService } from '@file-upload/services/files-state.service';

@Component({
  selector: 'app-file-download-notification',
  templateUrl: './file-download-notification.component.html',
  styleUrls: ['./file-download-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class FileDownloadNotificationComponent {
  readonly #snackBar = inject(MatSnackBar);
  readonly #filesStateService = inject(FilesStateService);
  readonly #destroyRef = inject(DestroyRef);

  openedSnackbar: MatSnackBarRef<FileDownloadListComponent>;

  constructor() {
    const files$ = this.#filesStateService.downloadingFiles$.pipe(
      takeUntilDestroyed(this.#destroyRef)
    );

    files$.subscribe(files => {
      if (!files.size) {
        this.closeSnackBar();
      }
    });

    files$.pipe(debounceTime(300)).subscribe(files => {
      if (files.size) {
        this.openSnackBar();
      }
    });
  }

  openSnackBar(): void {
    if (!this.openedSnackbar) {
      this.openedSnackbar = this.#snackBar.openFromComponent(
        FileDownloadListComponent,
        { duration: null, horizontalPosition: 'left' }
      );

      this.openedSnackbar
        .afterDismissed()
        .pipe(takeUntilDestroyed(this.#destroyRef))
        .subscribe(() => {
          this.openedSnackbar = null;
        });
    }
  }

  closeSnackBar(): void {
    if (!this.openedSnackbar) {
      return;
    }

    this.openedSnackbar.dismiss();
  }
}
